import { useContext } from "react";
import SurveyEditorContext from "../SurveyEditorContext";

export default function useSurvey() {
  const context = useContext(SurveyEditorContext);
  if (!context) {
    throw new Error("useSurvey must be used within a SurveyEditorContext");
  }
  return context;
}
